<app-spinner [loading]="spinnerService.loading$ | async"></app-spinner>
<div id="content-page-1">
  <div class="reddi-sub-menu-container">
    <app-sub-menu
      [clientId]="_clientId"
      [totalReviews]="_totalReviews"
      [flipHasAccess]="_hasAccess.flipHasAccess"
      [reddiHasAccess]="_hasAccess.reddiHasAccess"
      [slatHasAccess]="_hasAccess.slatHasAccess"
      [showBackButton]="true"
      [showCancelDialog]="false"
      (navigateBackClick)="previousRoute()"
    />
  </div>
  <div class="reddi-external-report-dummy"></div>
  <div id="report-content" class="reddi-external-report">
    <div class="external-report-heading">
      <div class="header-text">
        {{ 'REDDI REPORT HEADING' | translate }}
      </div>
      <div class="logo">
        <img [src]="path" alt="REDDI logo" class="reddi-logo" />
      </div>
    </div>
    <div class="client-details" translate>
      <strong>{{ 'Date' | translate }}:</strong>
      {{ _todayDate | date: 'dd/MM/yyyy' }}
    </div>
    <div id="client-details" class="client-details">
      <strong>{{ 'Name' | translate }}:</strong> {{ _title }}
      <strong class="client-margin">{{ 'Age' | translate }}:</strong>
      {{ _age }}
      <strong class="client-margin">{{ 'Date of Birth' | translate }}:</strong>
      {{ _dob }}
    </div>
    <div class="assessment-info">
      <p class="letter-spacing-para">
        {{ _clientName }}{{ 'REDDI SUMMARY' | translate }}
      </p>
      <p class="letter-spacing-para">
        {{ 'Below is a summary of' | translate }} {{ _clientName }}'s
        {{ 'access to sound between' | translate }} {{ _fromDisplayDate }} and
        {{ _toDisplayDate }}.
        {{ _listiningConditionText }}
      </p>
    </div>
    <div class="graph-section">
      <div class="reddi-report-graph">
        <div class="reddi-instance-locked-container">
          <span class="text">{{
            'This assessment is locked' | translate
          }}</span>
        </div>
        <div class="page-row">
          <div class="table-header-column-dummy"></div>
          <div class="table-header-column">{{ 'Left' | translate }}</div>
          <div class="table-header-column">{{ 'Right' | translate }}</div>
          <div class="table-header-column">{{ 'Everyday' | translate }}</div>
        </div>
        <table mat-table [dataSource]="_tableData">
          <ng-container
            *ngFor="let columnDef of _tableColumnDefinitions"
            [matColumnDef]="columnDef.columnName"
          >
            <th
              mat-header-cell
              *matHeaderCellDef
              [style.width]="columnDef.columnWidth"
              style="text-align: left"
            >
              {{ columnDef.header }}
            </th>
            <td
              mat-cell
              *matCellDef="let element; let i = index"
              [style.width]="columnDef.columnWidth"
              [style.text-align]="columnDef.columnTextAlign"
              [style.text-overflow]="'ellipsis'"
            >
              <span
                *ngIf="columnDef.columnType == 'string'"
                style="padding-right: 12px"
                >{{ element[columnDef.columnName] }}</span
              >
              <span
                *ngIf="columnDef.columnType == 'background-color'"
                [style.color]="
                  element[columnDef.columnName].type == 'imitation'
                    ? element[columnDef.columnName].color
                    : '#000000'
                "
                [style.background-color]="element[columnDef.columnName].color"
                class="background-color-style"
              >
                {{ getText(element[columnDef.columnName].type) }}</span
              >
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="_tableColumnsToDisplay"></tr>
          <tr
            mat-row
            *matRowDef="let row; let i = index; columns: _tableColumnsToDisplay"
          ></tr>
          <tr class="mat-row" *matNoDataRow>
            <td
              class="mat-cell table-no-data"
              [attr.colspan]="_tableColumnsToDisplay.length"
            >
              {{ noDataText }}
            </td>
          </tr>
        </table>
      </div>
      <app-reddi-graph-legend [showTitle]="true"></app-reddi-graph-legend>
    </div>
    <div class="assessment-info">
      <p *ngIf="this._sentence == 1" class="letter-spacing-para">
        {{ _clientName }} {{ 'Reddi Report Comment 1' | translate }}
      </p>
      <p *ngIf="this._sentence == 2" class="letter-spacing-para">
        {{ _clientName }} {{ 'Reddi Report Comment 2' | translate }}
      </p>
      <p *ngIf="this._sentence == 3" class="letter-spacing-para">
        {{ _clientName }} {{ 'Reddi Report Comment 3' | translate }}
      </p>
      <p class="comments" class="letter-spacing-para">{{ _comment }}</p>
    </div>
    <div class="contact-info-footer">
      <div class="page-row">
        <div class="page-column">
          <strong class="letter-spacing-para contact-labels">{{
            'Clinician name' | translate
          }}</strong
          >&NonBreakingSpace;
        </div>
        <div class="page-column">
          <p class="letter-spacing-para contact-margin">{{ _name }}</p>
        </div>
      </div>
      <div class="page-row">
        <div class="page-column">
          <strong class="letter-spacing-para contact-labels">
            {{ 'Title Role' | translate }}</strong
          >
          &NonBreakingSpace;
        </div>
        <div class="page-column">
          <p class="letter-spacing-para contact-margin">{{ _role }}</p>
        </div>
      </div>
      <div class="report-hearhub-logo">
        <app-hearhub-logo
          class="login-brand-logo"
          [inverted]="false"
        ></app-hearhub-logo>
      </div>
    </div>
  </div>
</div>

<div class="button-section">
  <app-action-button
    id="print-button"
    id="print-button"
    color="primary"
    kind="filled"
    size="large"
    type="button"
    (onClick)="generateReportPDF()"
    >{{ 'Download report' | translate }}</app-action-button
  >
</div>
